import { useState } from "react";
import { Container, Form } from "react-bootstrap";
import { InputFieldComponent } from "components/form/input_field";
import { CustomButton } from "components/buttons/custom_button";
import { logoImg } from "utils/data";

export const LoginPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };
  return (
    <section className="auth-page d-flex flex-column justify-content-center py-4">
      <Container>
        <section className="p-4 mx-auto max-width-600px login-card">
          <div className="mb-5">
            <div className="text-center mb-4">
              <img src={logoImg} alt="Logo" width="200px" />
            </div>
            <h1 className="text-white text-center m-0">Explore and Analyse</h1>
          </div>

          <Form className="d-flex flex-column gap-3" onSubmit={handleSubmit}>
            <h3 className="text-white m-0 fw-bold">Enter Login Details</h3>
            <InputFieldComponent
              type="text"
              placeholder="Full Name"
              name="fullName"
              required
              defaultValue={formData.fullName}
              onChange={handleChange}
            />
            <InputFieldComponent
              type="text"
              placeholder="Username"
              name="username"
              defaultValue={formData.username}
              required
              onChange={handleChange}
            />
            <InputFieldComponent
              type="password"
              name="password"
              required
              placeholder="Password"
              defaultValue={formData.password}
              onChange={handleChange}
            />

            <CustomButton type="submit" value="Continue" />
          </Form>
        </section>
      </Container>
    </section>
  );
};
